import React, { ReactNode, useEffect, useRef } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Snackbar from '@mui/material/Snackbar';

export type Severity = 'success' | 'error' | 'warning' | 'info';
const SnackbarAlert = ({
  open,
  title,
  content,
  severity,
  onClose,
  vertical = 'top',
  horizontal = 'center',
}: {
  open: boolean;
  title: string;
  content: ReactNode;
  severity: Severity;
  onClose(): void;
  vertical?: 'top' | 'bottom';
  horizontal?: 'center' | 'left' | 'right';
}) => {
  const liveRole = severity === 'error' || severity === 'warning' ? 'alert' : 'status';
  const ariaLive = severity === 'error' || severity === 'warning' ? 'assertive' : 'polite';
  const alertRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (open && alertRef.current) {
      alertRef.current.focus();
    }
  }, [open]);

  return (
    <Snackbar open={open} anchorOrigin={{ vertical: vertical, horizontal: horizontal }}>
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{ width: '100%' }}
        role={liveRole}
        aria-live={ariaLive}
        tabIndex={-1}
        ref={alertRef}
      >
        <AlertTitle>{title}</AlertTitle>
        {content}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarAlert;
